import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "18",
  height: "17",
  fill: "none"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "#003DA6",
      "fill-rule": "evenodd",
      d: "M14.727 13.29a1.48 1.48 0 1 1 0-2.958 1.48 1.48 0 0 1 0 2.958m0 .95a2.43 2.43 0 1 1 0-4.858 2.43 2.43 0 0 1 0 4.858",
      "clip-rule": "evenodd"
    }, null, -1),
    _createElementVNode("path", {
      fill: "#003DA6",
      "fill-rule": "evenodd",
      d: "M15.202 15.86v-2.43h-.95v2.43a.475.475 0 0 0 .95 0M14.727 0a.475.475 0 0 0-.475.475v8.907a.475.475 0 0 0 .95 0V.475A.475.475 0 0 0 14.727 0M8.578 3.045a1.48 1.48 0 1 1 0 2.958 1.48 1.48 0 0 1 0-2.958m0-.95a2.43 2.43 0 1 1 0 4.858 2.43 2.43 0 0 1 0-4.858",
      "clip-rule": "evenodd"
    }, null, -1),
    _createElementVNode("path", {
      fill: "#003DA6",
      "fill-rule": "evenodd",
      d: "M8.103.475v2.43h.95V.474a.475.475 0 0 0-.95 0M8.578 16.335a.475.475 0 0 0 .475-.475V6.953a.475.475 0 0 0-.95 0v8.907c0 .262.213.475.475.475M2.43 13.29a1.48 1.48 0 1 1 0-2.958 1.48 1.48 0 0 1 0 2.958m0 .95a2.43 2.43 0 1 1 0-4.858 2.43 2.43 0 0 1 0 4.858",
      "clip-rule": "evenodd"
    }, null, -1),
    _createElementVNode("path", {
      fill: "#003DA6",
      "fill-rule": "evenodd",
      d: "M2.904 15.86v-2.43h-.95v2.43a.475.475 0 0 0 .95 0M2.43 0a.475.475 0 0 0-.476.475v8.907a.475.475 0 0 0 .95 0V.475A.475.475 0 0 0 2.43 0",
      "clip-rule": "evenodd"
    }, null, -1)
  ]))]))
}
export default { render: render }